import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  message: {
    color: theme.palette.text.disabled,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: "center"
  },

  link: {
    color: theme.palette.jamii.mildBlue,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "center",
    cursor: "pointer"
  }
}));
